<div nxRow>
  <div nxCol="12,12,6,6">
    <div class="nx-margin-bottom-m">
      <h2 nxHeadline="section" class="nx-margin-bottom-s">
        {{ 'agreements.header' | translate }}
      </h2>
      <p *ngIf="isAnyRequiredAgreement$ | async" nxCopytext="normal" class="agreements-required">
        <span class="color-danger">*</span>
        {{ 'agreements.required' | translate }}
      </p>
    </div>

    <qbe-illustration name="womanWithLaptopTakingPictureOfDocument" class="agreements-illustration nx-margin-top-l"></qbe-illustration>
  </div>
  <div nxCol="12,12,6,6">
    <div class="nx-margin-bottom-m">
      <ng-content></ng-content>
    </div>

    <ng-container *ngIf="isAppDirect">
      <p nxCopytext="normal" class="nx-margin-bottom-m">
        <b>
          <span class="color-danger">*</span>
          {{ 'agreements.documents' + (remoteKindSuffix$ | async) | translate }}
        </b>
      </p>

      <button nxButton="secondary" type="button" class="nx-margin-bottom-m" (click)="showModal()">
        {{ 'agreements.documents-button' | translate }}
      </button>
    </ng-container>

    <nx-message *ngIf="isAllDownloaded$ | async" context="success">
      {{ 'agreements.all-downloaded' + (remoteKindSuffix$ | async) | translate }}
    </nx-message>
  </div>
</div>